import { memo, useContext, useMemo, useState } from "react";
import UseFetch from "hooks/useFetch";
import commentStatus from "constants/comment-statuses";
import moment from "jalali-moment";
import InitializeContext from "context/initialize-context";
import ChartLine from "../../shared/charts/line";
import ChartBoxSkeleton from "components/skeleton/chart-box";
import TinyListSkeleton from "components/skeleton/tiny-list";
import GoToAll from "components/shared/go-to-all";

const Comment = props => {
    const enums = useContext(InitializeContext);

    const activeForm = useMemo(() => {
        const intendedForm = enums.data.forms.find(form => !!form.comment_feature);
        if (intendedForm)
            return intendedForm.id;

        return null;
        // eslint-disable-next-line
    }, [])

    if (activeForm)
        return <Inner {...props} initActiveForm={activeForm} />

    return <></>
}

const Inner = props => {
    const { fetchUrl, initActiveForm } = props;
    const { data, isLoading, error } = UseFetch(fetchUrl);
    const enums = useContext(InitializeContext);
    const [activeForm, setActiveForm] = useState(initActiveForm);

    const statuses = useMemo(() => {
        const output = [];

        enums.data.forms.forEach(form => {
            if (form.comment_feature)
                output.push({
                    title: form.title,
                    value: form.id
                });
        });

        return output;
        // eslint-disable-next-line
    }, [])

    const activeFormLabel = useMemo(() => {
        const intendedForm = enums.data.forms.find(form => form.id === parseInt(activeForm));
        return intendedForm ? intendedForm.title : "";
        // eslint-disable-next-line
    }, [activeForm])

    const chartData = useMemo(() => {
        const counts = [];
        const days = [];

        if (!isLoading && !error && data.data.new_comment_graph_last_month[activeForm])
            data.data.new_comment_graph_last_month[activeForm].forEach(el => {
                counts.push(el.count);
                days.push(moment.unix(el.day).format("jYYYY/jMM/jD"));
            })

        return {
            counts,
            days
        }
    }, [isLoading, data, error, activeForm])

    return (
        <div className="grid grid-cols-12 gap-4 mb-4">
            <div className="col-span-full lg:col-span-8">
                {
                    !isLoading ? (
                        !error ? (
                            <div className="wrap-box tp-22 page-transition">
                                <h2 className="tp-34 text-sm font-bold pb-4">نمودار ایجاد کامنت ها</h2>

                                <div className="pt-3">
                                    <label className="select-c1 mb-8">
                                        <span>فرم انتخاب شده</span>

                                        <select onChange={e => setActiveForm(e.target.value)} value={activeForm}>
                                            {
                                                statuses.map(status => (
                                                    <option key={`option-${status.value}`} value={status.value}>{status.title}</option>
                                                ))
                                            }
                                        </select>
                                    </label>

                                    <ChartLine series={[{ name: 'تعداد', data: chartData.counts }]} xaxis={chartData.days} />
                                </div>
                            </div>
                        ) : <p className="text-red-500 text-xs">خطای سیستم!</p>
                    ) : <ChartBoxSkeleton />
                }
            </div>

            <div className="col-span-full lg:col-span-4">
                {
                    !isLoading ? (
                        !error ? (
                            <div className="wrap-box tp-22 page-transition">
                                <div className="state-box h-full flex flex-col">
                                    <div className="flex justify-between items-center mb-4 reset-i">
                                        <h2 className="title tp-34">وضعیت کامنت ها ({activeFormLabel})</h2>
                                        <GoToAll link={`/panel/comment?form_id=${activeForm}`} />
                                    </div>

                                    <div className="overflow-auto spec-sb-c2 pl-4">
                                        <ul>
                                            {
                                                commentStatus.map((status, i) => (
                                                    <li key={`content-status-${i}`}>
                                                        <div>
                                                            <span className="sec-title tp-34">{status.title}</span>
                                                        </div>

                                                        <b className="tp-34">
                                                            {data.data.comment_status[activeForm] ? data.data.comment_status[activeForm][i] || 0 : 0}
                                                        </b>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : <p className="text-red-500 text-xs">خطای سیستم!</p>
                    ) : <TinyListSkeleton />
                }
            </div>
        </div>
    )
}

export default memo(Comment);